// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Bitter:400,700);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@360;630&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.app {
  width: 100%;
  height: auto;
  min-height: calc(100vh - 96px);
  /* background: url(./images/Website_UI_BG.jpeg); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  word-wrap: break-word;
  line-height: initial;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAIhB;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kDAAkD;EAClD,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;AAClB","sourcesContent":["@charset \"UTF-8\";\n@import url(\"https://fonts.googleapis.com/css?family=Bitter:400,700\");\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@360;630&display=swap');\n\n* {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\n.app {\n  width: 100%;\n  height: auto;\n  min-height: calc(100vh - 96px);\n  /* background: url(./images/Website_UI_BG.jpeg); */\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  word-wrap: break-word;\n  line-height: initial;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
